import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import DotMenu from "shared/components/DotMenu";
import Icon, { ICONS } from "shared/components/Icon";
import { CHOICE_INDICATOR } from "components/FlowItemForm/types/MultipleChoiceAnswer";
import FlowItemInputSelect from "components/FlowItemInputSelect";

import "./style.scss";

const FlowItem = ({
    item,
    id,
    index,
    chapterIndex,
    zIndexValue,
    onEdit,
    onRemove,
    chapter,
    chapterId,
    osbn
}) => {

    const { t } = useTranslation();
    const indicatorClasses = classNames(
        "indicator",
        item.type,
    );
    const chapterString = JSON.stringify(chapter);

    const exp = new RegExp(id, "g");
    const isConnected = (chapterString.match(exp) || []).length >= 2;

    const flowItemClasses = classNames(
        "flow-item"
    );

    const renderNextItem = () => {

        if (item.result && chapter.items[item.result]) {
            const subIndicatorClasses = classNames(
                "indicator",
                chapter.items[item.result].type,
            );

            const itemKeys = Object.keys(chapter.items);
            let itemIndex = 0;

            itemKeys.some((key) => {
                itemIndex++;
                return key === item.result;
            });

            return (
                <span className={subIndicatorClasses}>
                    {`${chapterIndex}.${itemIndex}`}
                </span>
            );

        } else {
            return null;
        }

    };

    const handleOpenEdit = (id) => {
        const elements = document.querySelectorAll('[class*="list-movable-"]');

        elements.forEach((el) => {

            el.style.visibility = "hidden";
        });
        onEdit(id);
    };

    const handleOpenDelete = (id) => {
        const elements = document.querySelectorAll('[class*="list-movable-"]');

        elements.forEach((el) => {

            el.style.visibility = "hidden";
        });
        onRemove(id);
    };

    return (
        <div className="container-flow-item" style={{ position: "static" }}>
            <div

                draggable="true"
                className={flowItemClasses}
            >
                <div className="flow-content">
                    <span className={indicatorClasses}>
                        {`${chapterIndex}.${index + 1}`}
                    </span>
                    {!isConnected &&
                        <span className="not-connected">
                            <Icon
                                name={ICONS.WARNING}
                                spacedRight
                            />
                        </span>
                    }
                    <span className="label">{item.label || t(`book.flowItem.${item.type}`)}</span>
                    {renderNextItem()}
                </div>
                {item.type !== "selectOption" && item.type !== "numericValue" && (<FlowItemInputSelect
                    onOpen={() => {
                        const match = zIndexValue.match(/list-movable-child-(\d+)-/);
                        const currentChapter = parseInt(match[1], 10);

                        const dotMenu = document.querySelector(`.${zIndexValue}`);

                        if (dotMenu) dotMenu.style.zIndex = "99";

                        const nextChapter = document.querySelector(`.list-movable-${currentChapter}`);

                        if (nextChapter) nextChapter.setAttribute("style", "position: unset !important;");

                        const allDotMenus = document.querySelectorAll(`.actions`);
                        allDotMenus.forEach((el) => {
                            el.setAttribute("style", "position: unset !important;");
                        });

                    }}
                    onBlur={() => {
                        const dotMenu = document.querySelector(`.${zIndexValue}`);
                        if (dotMenu) dotMenu.style.zIndex = "0";
                        const match = zIndexValue.match(/list-movable-child-(\d+)-/);
                        const currentChapter = parseInt(match[1], 10);
                        const nextChapter = document.querySelector(`.list-movable-${currentChapter}`);

                        if (nextChapter) nextChapter.setAttribute("style", "position: relative;");

                        const allDotMenus = document.querySelectorAll(`.actions`);
                        allDotMenus.forEach((el) => {
                            el.setAttribute("style", "position: relative !important;");
                        });

                    }}
                    chapterItems={chapter.items}
                    flowItem={item}
                    flowItemId={id}
                    chapter={chapter}
                    chapterId={chapterId}
                    chapterIndex={chapterIndex}
                    itemSelectedResult={item.result}
                    osbn={osbn}

                />)}
                <div className="actions">

                    <button
                        data-movable-handle
                        style={{
                            cursor: "grab",
                            marginRight: "1em",
                            background: "none",
                            border: "none",
                            display: index === 0 && item?.isIntroduction === true
                                ? "none"
                                : "block",
                        }}
                    >
                        <Icon name={ICONS.DRAG} />
                    </button>
                    <DotMenu
                        onOpen={() => {
                            const dotMenu = document.querySelector(`.${zIndexValue}`);
                            if (dotMenu) dotMenu.style.zIndex = "99";
                        }}
                        onBlur={() => {
                            const dotMenu = document.querySelector(`.${zIndexValue}`);
                            if (dotMenu) dotMenu.style.zIndex = "0";
                        }}
                        menuItems={[
                            { action: () => handleOpenEdit(id), label: t("book.flowItem.edit.button") },
                            ...(index !== 0
                                ? [{ action: () => handleOpenDelete(id), label: t("book.flowItem.delete.button") }]
                                : [])
                        ]}

                    />
                </div>
            </div>
            {item.comparisons?.length > 0 && (
                <div className="answer-results">
                    {item.comparisons.map((comparison, index) => {
                        const { result, operator, value } = comparison;

                        if (!result || (!chapter.items[result] && result !== "END")) {
                            return null;
                        }

                        const isEnd = result === "END";

                        const subIndicatorClasses = classNames(
                            "indicator",
                            isEnd ? "end" : chapter.items[result].type
                        );

                        let itemLabel = "";
                        if (!isEnd) {
                            const itemKeys = Object.keys(chapter.items);
                            let itemIndex = 0;
                            itemKeys.some((key) => {
                                itemIndex++;
                                return key === result;
                            });
                            itemLabel = `${chapterIndex}.${itemIndex}`;
                        }

                        return (
                            <div className="answer-result" key={index}>
                                <div className="answer-content">
                                    <span className="answer-condition">
                                        <strong>{t(`book.numericValue.operator.${operator}`)}:</strong> {value}
                                    </span>

                                </div>
                                <div className="answer-content">
                                    {!isEnd && (
                                        <span className={subIndicatorClasses}>
                                            {itemLabel}
                                        </span>
                                    )}
                                    <FlowItemInputSelect
                                        onOpen={() => {
                                            const dotMenu = document.querySelector(`.${zIndexValue}`);
                                            if (dotMenu) dotMenu.style.zIndex = "99";
                                        }}
                                        onBlur={() => {
                                            const dotMenu = document.querySelector(`.${zIndexValue}`);
                                            if (dotMenu) dotMenu.style.zIndex = "0";
                                        }}
                                        chapterItems={chapter.items}
                                        flowItem={item}
                                        flowItemId={id}
                                        chapter={chapter}
                                        chapterId={chapterId}
                                        chapterIndex={chapterIndex}
                                        itemSelectedResult={item.result}
                                        osbn={osbn}
                                        childInputSelectKey={comparison}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {item.answers?.length > 0 &&
                <div className="answer-results">
                    {item.answers.map((answer, index) => {

                        if (!answer?.result || (!chapter.items[answer.result] && answer.result !== "END")) {
                            return null;
                        }

                        const isEnd = answer.result === "END";

                        const subIndicatorClasses = classNames(
                            "indicator",
                            isEnd ? "end" : chapter.items[answer.result].type
                        );

                        let itemLabel = "";
                        if (!isEnd) {
                            const itemKeys = Object.keys(chapter.items);
                            let itemIndex = 0;
                            itemKeys.some((key) => {
                                itemIndex++;
                                return key === answer.result;
                            });
                            itemLabel = `${chapterIndex}.${itemIndex}`;
                        }

                        return (
                            <div className="answer-result" key={index}>
                                <div className="answer-content">
                                    <span className="choice-indicator">
                                        {CHOICE_INDICATOR[index]}
                                    </span>
                                    <span>{answer.label}</span>
                                </div>
                                <div className="answer-content"> {!isEnd && (
                                    <span className={subIndicatorClasses}>
                                        {itemLabel}
                                    </span>
                                )}
                                    <FlowItemInputSelect
                                        onOpen={() => {
                                            const dotMenu = document.querySelector(`.${zIndexValue}`);
                                            if (dotMenu) dotMenu.style.zIndex = "99";
                                        }}
                                        onBlur={() => {
                                            const dotMenu = document.querySelector(`.${zIndexValue}`);
                                            if (dotMenu) dotMenu.style.zIndex = "0";
                                        }}
                                        chapterItems={chapter.items}
                                        flowItem={item}
                                        flowItemId={id}
                                        chapter={chapter}
                                        chapterId={chapterId}
                                        chapterIndex={chapterIndex}
                                        itemSelectedResult={item.result}
                                        osbn={osbn}
                                        childInputSelectKey={answer}

                                    /> </div>

                            </div>
                        );
                    })}
                </div>
            }
        </div>
    );
};

FlowItem.propTypes = {
    item: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    chapterIndex: PropTypes.number.isRequired,
    onEdit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    chapter: PropTypes.string,
};

export default FlowItem;